<template>
  <div>
    <v-container fill-height class="mt-md-5">
      <v-row>
        <v-col cols="12" md="6">
          <h1 class="mb-5">Digitalisasi Surat Menyurat</h1>
          <div class="subtitle-1">
            <p>Sistem informasi digitalisasi surat merupakan sebuah sistem yang dapat membantu proses pelayanan surat menyurat secara online.</p>
            <p>Layanan ini bertujuan agar proses pelayanan surat menyurat dapat berjalan lebih efektif dan efisien serta sebagai upaya mengurangi penggunakan kertas.</p>
          </div>
          <div>
            <v-btn
              class="ma-2 ml-md-0"
              large
              outlined
              color="success"
              @click="openTab('get-account')"
              v-scroll-to="'#getaccount-elm'">
              <v-icon left>person_add</v-icon> Dapatkan Akun
            </v-btn>
            <v-btn
              class="ma-2"
              large
              color="success"
              :to="{ name: 'Login' }"
              exact>
              <v-icon left>lock_open</v-icon> Masuk Sistem
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <v-img :src="require('../assets/ilustrasi-proses.gif')" aspect-ratio="1.7"></v-img>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="mb-5 text-center" id="getaccount-elm">Panduan</h1>
          <v-tabs
            v-model="panduan"
            :background-color="maincolor"
            center-active
            dark
            centered
            show-arrows>
            <v-tab href="#get-account">Mendapatkan Akun</v-tab>
            <v-tab href="#login-system">Masuk Sistem</v-tab>
            <v-tab href="#letter-submission">Pengajuan Surat</v-tab>
            <v-tab href="#letter-checking">Pengecekan Surat</v-tab>
            <v-tab href="#manual-book">Buku Panduan</v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="panduan" class="pa-3">
            <v-tab-item value="get-account">
              <div class="subtitle-1 text-center">
                <p>Berikut ini merupakan panduan untuk mendapatkan akun pada sistem ini.</p>
              </div>
              <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
                <v-timeline-item
                  color="red lighten-2"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="red lighten-2"
                    dark>
                    <v-card-title class="title py-3">Datang Ke Kantor Desa</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Datang ke kantor desa dengan membawa kelengkapan berkas seperti <b>Kartu Keluarga dan KTP</b>, antri di <b>bagian administrasi</b></p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="purple darken-1"
                  icon="mdi-book-variant"
                  fill-dot>
                  <v-card
                    color="purple darken-1"
                    dark>
                    <v-card-title class="title py-3">Ajukan Permohonan</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Ajukan permohonan untuk pembuatan akun baru dengan <b>menyerahkan kelengkapan berkas</b> kepada petugas input.</p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="green lighten-1"
                  icon="mdi-airballoon"
                  fill-dot>
                  <v-card
                    color="green lighten-1"
                    dark>
                    <v-card-title class="title py-3">Pembuatan Akun</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Petugas akan membuatkan akun sesuai dengan data yang ada pada berkas.</p>
                      <p>Setelah akun dibuat, <b>petugas akan memberikan password</b> untuk mengakses Sistem Informasi Digitalisasi Surat melalui tautan berikut <v-btn x-small outlined color="success" :to="{ name: 'Login' }">Login</v-btn></p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-tab-item>
            <v-tab-item value="login-system">
              <div class="subtitle-1 text-center">
                <p>Berikut ini merupakan panduan untuk masuk dan mendapat akses pada sistem ini.</p>
              </div>
              <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
                <v-timeline-item
                  color="red lighten-2"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="red lighten-2"
                    dark>
                    <v-card-title class="title py-3">Kunjungi Website</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Kunjungi website Sistem Informasi Digitalisasi Surat pada alamat <a :href="staticdata.website" target="_blank" :title="'Sistem Informasi Digitalisasi Surat - Desa ' + staticdata.desa">{{ staticdata.website }}</a></p>
                      <div>
                        <v-img class="img-detail-link" @click="showImageDetail('main-top-min.png')" :src="require('../assets/' + prefix + '/main-top-min.png')" aspect-ratio="1.7"></v-img>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="purple darken-1"
                  icon="mdi-book-variant"
                  fill-dot>
                  <v-card
                    color="purple darken-1"
                    dark>
                    <v-card-title class="title py-3">Pilih Menu Login</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Pilih menu <router-link :to="{ name: 'Login' }">Login</router-link> pada sebelah kanan atas untuk menuju halaman login. Kemudian masukan <b>NIK</b> sebagai username dan <b>password</b> yang sebelumnya didapat dari kantor desa, lalu klik tombol <b>Login</b></p>
                      <div>
                        <v-img class="img-detail-link" @click="showImageDetail('login-min.png')" :src="require('../assets/' + prefix + '/login-min.png')" aspect-ratio="1.7"></v-img>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="green lighten-1"
                  icon="mdi-airballoon"
                  fill-dot>
                  <v-card
                    color="green lighten-1"
                    dark>
                    <v-card-title class="title py-3">Lupa Password</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Jika anda lupa password akun anda, segera hubungi petugas administrasi di kantor desa. Kontak petugas kantor desa dapat anda temukan di halaman <router-link :to="{ name: 'Contact' }">Kontak</router-link></p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-tab-item>
            <v-tab-item value="letter-submission">
              <div class="subtitle-1 text-center">
                <p>Berikut ini merupakan panduan untuk mengajukan surat pada sistem ini.</p>
              </div>
              <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
                <v-timeline-item
                  color="red lighten-2"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="red lighten-2"
                    dark>
                    <v-card-title class="title py-3">Pilih Menu Surat</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Pilih menu <router-link :to="{ name: 'SuratGuest' }">Surat</router-link> yang ada pada sebelah kanan atas layar. Pastikan anda sudah login untuk dapat menemukan menu ini.</p>
                      <div>
                        <v-img class="img-detail-link" @click="showImageDetail('surat-list-penduduk-min.png')" :src="require('../assets/'+ prefix +'/surat-list-penduduk-min.png')" aspect-ratio="1.7"></v-img>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
                <v-timeline-item
                  color="purple darken-1"
                  icon="mdi-book-variant"
                  fill-dot>
                  <v-card
                    color="purple darken-1"
                    dark>
                    <v-card-title class="title py-3">Pilih Menu Buat Baru</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Pilih menu Buat Baru untuk membuka form pengajuan surat baru. Kemudian pilih <b>Jenis Surat</b> yang akan dibuat, isikan <b>Deskripsi Keterangan Surat</b>, kemudian check <b>Nama Orang</b> yang mengajukan. Setelah itu klik tombol <b>Simpan</b></p>
                      <div>
                        <v-img class="img-detail-link" @click="showImageDetail('surat-add-penduduk-min.png')" :src="require('../assets/' + prefix + '/surat-add-penduduk-min.png')" aspect-ratio="1.7"></v-img>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-tab-item>
            <v-tab-item value="letter-checking">
              <div class="subtitle-1 text-center">
                <p>Berikut ini merupakan panduan untuk pengecekan status surat pada sistem ini.</p>
              </div>
              <v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
                <v-timeline-item
                  color="red lighten-2"
                  icon="mdi-star"
                  fill-dot>
                  <v-card
                    color="red lighten-2"
                    dark>
                    <v-card-title class="title py-3">Pengecekan dengan Menu Cek</v-card-title>
                    <v-card-text class="white text--primary py-3">
                      <p>Pengecekan dengan menu <router-link :to="{ name: 'Check' }">Cek</router-link> ini dapat dilakuakn tanpa Login atau masuk ke dalam sistem. Pilih menu <router-link :to="{ name: 'Check' }">Cek</router-link> yang ada pada sebelah kanan atas layar.</p>
                      <p>Kemudian masukan <b>Nomor Referensi Surat</b>, lalu klik tombol <b>Periksa</b>. Hasil akan ditampilkan pada bagian <b>Hasil Pemeriksaan</b></p>
                      <p>
                        Terdapat enam (6) jenis status dalam pengajuan surat, yaitu:
                        <ul>
                          <li><u>Acc-banjar</u>, yaitu surat masih dalam pengajuan ke Klian Dinas dan belum diproses oleh pihak Klian Dinas.</li>
                          <li><u>Permohonan</u>, yaitu surat masih dalam pengajuan dan belum diproses oleh pihak kantor desa.</li>
                          <li><u>Proses</u>, yaitu surat telah diproses oleh pihak kantor desa dengan melakukan validasi data, cetak surat, dan pemberian tanda tangan dan cap basah.</li>
                          <li><u>Siap</u>, yaitu surat telah siap, pemohon dapat mengambil langsung di kantor desa.</li>
                          <li><u>Selesai</u>, yaitu surat telah diambil oleh pemohon.</li>
                          <li><u>Batal</u>, yaitu surat ditolak atau dibatalkan oleh pihak kantor desa atau Klian Dinas.</li>
                        </ul>
                      </p>
                      <div>
                        <v-img class="img-detail-link" @click="showImageDetail('checksurat-min.png')" :src="require('../assets/' + prefix + '/checksurat-min.png')" aspect-ratio="1.7"></v-img>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-tab-item>
            <v-tab-item value="manual-book">
              <div class="subtitle-1 text-center">
                <p>Berikut ini merupakan buku panduan sistem informasi ini.</p>
                <div>
                  <object
                    :data="'/img/usermanual-penduduk-' + prefix + '.pdf'"
                    type="application/pdf"
                    class="pdf-embed-custom">
                    <p>
                      Web browser anda tidak memiliki PDF plugin.<br>
                      Sebaliknya anda dapat download buku panduan pada tautan berikut:<br>
                      <a target="_blank" :href="'/img/usermanual-penduduk-' + prefix + '.pdf'">
                        Download
                      </a>
                    </p>
                  </object>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
    <!-- modal - update -->
    <v-dialog
      persistent
      v-model="dmodal.imagedetail"
      max-width="100%"
      width="900px"
      v-if="dmodaldata.imagedetail !== ''">
      <v-card>
        <v-card-text class="pt-5">
          <v-img :src="require('../assets/' + prefix + '/' + dmodaldata.imagedetail)" width="100%"></v-img>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeDmodal('imagedetail')">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Landing',
  data: () => ({
    word: 'Vue',
    maincolor: process.env.VUE_APP_MAINCOLOR,
    prefix: process.env.VUE_APP_PREFIX,
    panduan: 'get-account',
    dmodal: {
      imagedetail: false,
    },
    dmodaldata: {
      imagedetail: '',
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'staticdata',
    ]),
  },
  methods: {
    openTab(tabname) {
      this.panduan = tabname;
    },
    closeDmodal(type) {
      if (type === 'imagedetail') {
        this.dmodal.imagedetail = false;
      } else {
        this.dmodal.imagedetail = false;
      }
    },
    showImageDetail(item) {
      this.dmodaldata.imagedetail = '';
      this.dmodal.imagedetail = true;
      this.dmodaldata.imagedetail = item;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .pdf-embed-custom{
    width: 850px;
    max-width: 100%;
    height: 100vh;
    margin: auto;
  }
  .img-detail-link{
    cursor: pointer;
  }
</style>
